import sha256 from 'crypto-js/sha256';

export default function hashedPassword(credential) {
  const hash = sha256(credential).toString();
  return hash;
}